import { Link } from "react-router-dom";
import { topics } from "@/mocks/content";

export default function TopicGrid() {
  return (
    <section className="w-full">
      <div className="mb-4">
        <h2 className="font-heading text-xl font-extrabold text-foreground-950">专题策划推荐</h2>
        <p className="mt-1 text-sm text-foreground-600">编辑精选的主题合集，带你系统探索热门内容</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={`/category/${topic.category}`}
            className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-lg bg-foreground-950 p-5"
          >
            <img
              src={topic.cover}
              alt={topic.title}
              title={`${topic.title} - 快猫专题`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
            <div className="relative z-10">
              <span className="w-fit rounded-full bg-primary-500 px-2.5 py-1 font-label text-xs font-semibold text-background-50">
                专题
              </span>
              <h3 className="mt-2 font-heading text-lg font-bold text-background-50">{topic.title}</h3>
              <p className="mt-1 line-clamp-2 text-sm text-background-200">{topic.intro}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}